import React from 'react';
//import PropTypes from 'prop-types';

import { getContactFieldData } from '../config';
import { createUseStyles } from '../palette';
import decorate from '../common/utils/decorate';
import AddressInput from '../common/components/AddressInput';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Divider from '../ui/Divider';
import Grid from '../ui/Grid';
import Text from '../ui/Text';
import TextInput from '../ui/TextInput';
import Skeleton from '../ui/Skeleton';

import Query from './Query';

const useStyles = createUseStyles((theme) => ({
  preliminarySkeleton: {
    width: 150
  }
}));

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {
      classes: useStyles
    };

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);

      this.state = {
        action: null,
        error: null,
        timeout: 0
      };
    }

    getAddress = () => {
      const { localityData, address } = this.context;

      if (!address) return null;

      if (!address.address?.locality)
        return {
          ...address,
          address: {
            ...address.address,
            locality: AddressInput.buildValue(
              'delivery',
              'locality',
              localityData
            )
          }
        };

      return address;
    };

    onCreateOrder = () => {
      const { onNextPage, onPrevPage } = this.props;

      const {
        shop,
        site,
        currency,
        cart,
        editor,

        apiRequest
      } = this.context;

      const address = this.getAddress();

      if (!address || this.state.action) return;

      this.state.action = 'submitting-start';

      this.setState((state) => ({ ...state, action: 'submitting' }));

      if (editor) {
        onNextPage({
          ...address,

          shop,
          site,
          currency,
          cart,

          onSuccess: () =>
            this.setState((state) => ({ ...state, action: null })),
          onError: (error) =>
            this.setState((state) => ({ ...state, action: null, error }))
        });
      } else {
        apiRequest('delivery/order/create', {
          ...address,
          shop,
          site,
          currency,
          cart: cart.list
        })
          .then(onNextPage)
          .catch((error) => {
            if (error.code === 'visitor-unauthorized') {
              this.onAuthorizeUser();
            } else if (error.code === 'data-wrong' && error.data?.goods) {
              onPrevPage(error);
            } else {
              console.error(error);

              this.setState((state) => ({ ...state, action: null, error }));
            }
          });
      }
    };

    onAuthorizeUser = () => {
      const { onPrevPage } = this.props;

      const {
        shop,
        site,
        authorizeType,
        referralParent,

        apiRequest,
        scrollTop,

        address
      } = this.context;

      const authorizeParam = { place: shop, site, type: authorizeType };
      authorizeParam.lastname = address.recipient.lastname;
      authorizeParam.firstname = address.recipient.firstname;
      authorizeParam.patronymic = address.recipient.patronymic;
      authorizeParam.email = address.recipient.email;
      authorizeParam.mobile = address.recipient.phone;

      if (referralParent) authorizeParam.parent = referralParent;

      apiRequest('client/visitor/authorize_create', authorizeParam)
        .then((data) => {
          if (data.confirm) {
            this.setState((state) => ({
              ...state,
              action: 'code',
              code: '',
              codeType: data.type,
              timeout: 0
            }));

            scrollTop();
          } else {
            this.onCreateOrder();
          }
        })
        .catch((error) =>
          error.code === 'data-incorrect'
            ? onPrevPage()
            : error.code === 'data-timeout'
            ? this.setState((state) => ({
                ...state,
                timeout: error.data.timeout
              }))
            : this.setState((state) => ({ ...state, error }))
        );
    };

    onAuthorizeConfirm = () => {
      const { apiRequest } = this.context;

      if (this.state.action !== 'code' && this.state.action !== 'code-invalid')
        return;

      const code = this.state.code;

      this.state.action = 'code-check';

      this.setState((state) => ({ ...state, action: 'code-check', code: '' }));

      apiRequest('client/security/confirm', { type: 'action', value: code })
        .then((data) => {
          this.state.action = null;
          this.onCreateOrder();
        })
        .catch((error) =>
          this.setState((state) => ({ ...state, action: 'code-invalid' }))
        );
    };

    renderField = (field_item) => {
      const {
        langString,

        address
      } = this.context;

      return (
        <TextInput
          {...field_item.props}
          key={field_item.name}
          readOnly
          required={false}
          label={langString(field_item.props.label)}
          value={
            (field_item.path ? address[field_item.path] : address)[
              field_item.name
            ] || ''
          }
        />
      );
    };

    renderCartChildren = (method, company, tariff, point) => {
      const { classes } = this.props;

      const {
        langString,
        priceFormat,
        daysFormat,

        address
      } = this.context;

      const preliminaryData = this.state.preliminaryData;

      return (
        <Grid container>
          <Grid>
            {address?.service !== 'internal' ? (
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="lg">
                    {method && company ? (
                      <>
                        {company?.title} ({tariff?.title})
                      </>
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
            ) : null}

            <div>
              <div>
                <Text strong color="hint" size="lg">
                  {langString('delivery')}:
                </Text>
              </div>
              <div>
                <Text color="hint" size="lg">
                  {method && company ? (
                    method?.title
                  ) : (
                    <Skeleton className={classes.preliminarySkeleton} />
                  )}
                </Text>
              </div>
            </div>

            <div>
              <div>
                <Text strong color="hint" size="lg">
                  {langString('delivery.time')}:
                </Text>
              </div>
              <div>
                <Text color="hint" size="lg">
                  {preliminaryData ? (
                    daysFormat(preliminaryData.days)
                  ) : (
                    <Skeleton className={classes.preliminarySkeleton} />
                  )}
                </Text>
              </div>
            </div>

            {method?.code === 'pickup' ? (
              <>
                <div>
                  <div>
                    <Text strong color="hint" size="lg">
                      {langString('point')}:
                    </Text>
                  </div>
                  <div>
                    <Text color="hint" size="lg">
                      {point ? (
                        point?.title
                      ) : (
                        <Skeleton className={classes.preliminarySkeleton} />
                      )}
                    </Text>
                  </div>
                </div>

                <div>
                  <div>
                    <Text strong color="hint" size="lg">
                      {langString('point.address')}:
                    </Text>
                  </div>
                  <div>
                    <Text color="hint" size="lg">
                      {point ? (
                        point?.address
                      ) : (
                        <Skeleton className={classes.preliminarySkeleton} />
                      )}
                    </Text>
                  </div>
                </div>
              </>
            ) : null}

            <Grid container align="end">
              <Grid>
                <Text strong color="hint" size="lg">
                  {langString('delivery.price')}:
                </Text>
              </Grid>
              <Grid align="end">
                <Text strong color="hint" size="xl">
                  {preliminaryData ? (
                    priceFormat(preliminaryData.price)
                  ) : (
                    <Skeleton className={classes.preliminarySkeleton} />
                  )}
                </Text>
              </Grid>
            </Grid>

            <Grid container>
              <Grid>
                <Divider />
              </Grid>
            </Grid>

            <Grid container align="end">
              <Grid>
                <Text strong color="hint" size="xl">
                  {langString('amount')}:
                </Text>
              </Grid>
              <Grid align="end">
                <Text strong size="xl2">
                  {preliminaryData ? (
                    priceFormat(preliminaryData.amount)
                  ) : (
                    <Skeleton className={classes.preliminarySkeleton} />
                  )}
                </Text>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderCartGoods = (preliminaryData, cart_index, in_stock) => {
      const { langString, priceFormat } = this.context;

      const color = in_stock ? 'basic' : 'danger';

      return (
        <Card variant="bordered" color={color}>
          <Grid container>
            <Grid>
              <Text strong color={color}>
                {langString(in_stock ? 'goods.stock.in' : 'goods.stock.out')}
              </Text>

              {preliminaryData ? (
                <>
                  {preliminaryData?.cart[cart_index]?.map((item, index) => (
                    <Grid key={index} container>
                      <Grid>
                        <Text color={color}>{item.title}</Text>
                      </Grid>
                      <Grid grow={0}>
                        <Text color={color} whiteSpace="nowrap">
                          {priceFormat(item.price - item.discount)}
                        </Text>
                      </Grid>
                      <Grid grow={0}>
                        <Text color={color} whiteSpace="nowrap">
                          {langString('pcs').replace('%', item.count)}
                        </Text>
                      </Grid>
                    </Grid>
                  ))}
                </>
              ) : (
                <Skeleton />
              )}
            </Grid>
          </Grid>
        </Card>
      );
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { onPrevPage } = this.props;

      const {
        shop,
        site,
        currency,
        cart,

        langString,
        apiRequest,
        
        service,
        methodList,
        companyList,
        tariffList,

        isSmall
      } = this.context;

      const address = this.getAddress();

      if (this.state.preliminaryData === undefined) {
        this.state.preliminaryData = null;

        apiRequest('delivery/order/preliminary', {
          ...address,
          shop,
          site,
          currency,
          cart: cart.list
        })
          .then((preliminaryData) =>
            this.setState((state) => ({ ...state, preliminaryData }))
          )
          .catch((error) => {
            console.error(error);

            this.setState((state) => ({
              ...state,
              preliminaryData: {},
              error
            }));
          });
      }
      
      const action = this.state.action;
      const preliminaryData = this.state.preliminaryData;
      
      const method = methodList.find((method) => method.id === address.method);
      const company = companyList.find((company) => company.service.code === service.code && company.id === address.company);
      const tariff = tariffList.find((tariff) => tariff.service.code === service.code && tariff.id === address.tariff);
      const point = address.point;
      
      if (action === 'code' || action === 'code-check' || action === 'code-invalid') {
        return (
          <Query
            cart={cart}
            cartChildren={this.renderCartChildren(method, company, tariff, point)}
            rightChildren={
              <Button
                variant="contained"
                disabled={action === 'code-check'}
                onClick={this.onAuthorizeConfirm}
              >
                {langString('security.code.check')}
              </Button>
            }
          >
            <Card variant="bordered">
              <Grid container>
                <Grid>
                  <Text strong>
                    {this.state.codeType === 'sms'
                      ? langString('security.sms.note').replace(
                          '%',
                          address.recipient.phone
                        )
                      : this.state.codeType === 'fcall'
                      ? langString('security.fcall.note').replace(
                          '%',
                          address.recipient.phone
                        )
                      : langString('security.email.note').replace(
                          '%',
                          address.recipient.email
                        )}
                  </Text>

                  <TextInput
                    placeholder={langString(
                      this.state.codeType === 'sms'
                        ? 'security.sms.enter'
                        : this.state.codeType === 'fcall'
                        ? 'security.fcall.enter'
                        : 'security.email.enter'
                    )}
                    value={this.state.code}
                    onChange={(event) => {
                      const code = event.target.value;
                      this.setState((state) => ({ ...state, code }));
                    }}
                    note={
                      action === 'code-invalid' ? langString('code.bad') : null
                    }
                    isError={action === 'code-invalid'}
                  />

                  <Button
                    variant="outlined"
                    onClick={() =>
                      this.setState((state) => ({ ...state, action: null }))
                    }
                  >
                    {langString('cancel')}
                  </Button>
                </Grid>
              </Grid>
            </Card>
          </Query>
        );
      } else {
        return (
          <Query
            cart={cart}
            cartChildren={this.renderCartChildren(method, company, tariff, point)}
            rightChildren={
              <Button
                variant="contained"
                disabled={action || !preliminaryData?.next}
                onClick={this.onCreateOrder}
              >
                {langString('confirm.correctness')}
              </Button>
            }
          >
            <Grid container>
              <Grid>
                {getContactFieldData(method, company).map(
                  (data_item, data_index) => (
                    <Card key={data_index} variant="bordered">
                      <Grid container>
                        <Grid>
                          <Text strong>{langString(data_item.title)}</Text>

                          {data_item.fields.map((field_list, group_index) => (
                            <React.Fragment key={group_index}>
                              {isSmall ? (
                                <>
                                  {field_list.map((field_item, field_index) =>
                                    this.renderField(field_item)
                                  )}
                                </>
                              ) : (
                                <Grid container align="start">
                                  {field_list.map((field_item, field_index) => (
                                    <Grid key={field_index}>
                                      {this.renderField(field_item)}
                                    </Grid>
                                  ))}
                                </Grid>
                              )}
                            </React.Fragment>
                          ))}
                        </Grid>
                      </Grid>
                    </Card>
                  )
                )}

                {!preliminaryData || preliminaryData.cart ? (
                  <>
                    {!preliminaryData || preliminaryData.cart[0]?.length
                      ? this.renderCartGoods(preliminaryData, 0, true)
                      : null}
                    {preliminaryData && preliminaryData.cart[1]?.length
                      ? this.renderCartGoods(preliminaryData, 1, false)
                      : null}
                  </>
                ) : null}

                <Text size="xs2">{langString('delivery.confirm.note')}</Text>

                {preliminaryData?.message ? (
                  <Card variant="bordered" color="info">
                    <Text color="info">{preliminaryData.message}</Text>
                  </Card>
                ) : null}

                {this.state.error ? (
                  <Card variant="bordered" color="warning">
                    <Text color="warning">
                      {this.state.error?.message || String(this.state.error)}
                    </Text>
                  </Card>
                ) : null}

                <Button variant="outlined" onClick={(event) => onPrevPage()}>
                  {langString('recipient.return')}
                </Button>
              </Grid>
            </Grid>
          </Query>
        );
      }
    }
  }
);
